import React from "react";
import "./SpinnerField.scss";
import {Loader} from "@surfnet/sds";

export default function SpinnerField() {
    return (
        <Loader/>);
}